import React from 'react';

/**
 * RAW MIXES brand logo.
 * Uses the DJ turntable SVG icon (black + gold) alongside the wordmark.
 */
export const Logo = ({ size = 'md', className = '', iconOnly = false }) => {
  const sizes = {
    sm: { icon: 40, mixes: 16, raw: 8, gap: 'gap-2.5' },
    md: { icon: 56, mixes: 22, raw: 10, gap: 'gap-3' },
    lg: { icon: 80, mixes: 32, raw: 14, gap: 'gap-4' },
    xl: { icon: 120, mixes: 48, raw: 22, gap: 'gap-5' },
  };
  const s = sizes[size] || sizes.md;

  const iconEl = (
    <img
      src="/rawmixes-logo.png"
      alt="Raw Mixes"
      width={s.icon}
      height={s.icon}
      className="flex-shrink-0 rounded-full"
      style={{ width: s.icon, height: s.icon }}
    />
  );

  if (iconOnly) {
    return (
      <div className={className} data-testid="logo-rawmixes">
        {iconEl}
      </div>
    );
  }

  return (
    <div
      className={`flex items-center ${s.gap} ${className}`}
      data-testid="logo-rawmixes"
    >
      {iconEl}
      <div className="flex flex-col leading-none">
        <span
          className="font-heading font-black tracking-[0.3em] text-[#FFB000]"
          style={{ fontSize: s.raw, marginBottom: s.raw * 0.3 }}
        >
          RAW
        </span>
        <span
          className="font-heading font-black tracking-tight text-white"
          style={{ fontSize: s.mixes, letterSpacing: '-0.02em' }}
        >
          MIXES
        </span>
      </div>
    </div>
  );
};

export default Logo;
